const Transport = require('winston').Transport;

/**
 * Transport to send log info from main process to renderer.
 * Note: Use with caution in production.
 */
class IpcTransport extends Transport {
    channel: string;
    webContents: Electron.WebContents;

    constructor(opts) {
        super(opts);

        this.channel = opts.channel || 'cen-log';
        this.webContents = undefined;
    }

    log(info, callback) {

        // Check if webContents exists.
        if (typeof this.webContents !== 'object') {
            if (typeof (global as any).mainWindow === 'object') {
                this.webContents = (global as any).mainWindow.webContents;
            }
        }

        // Send log info.
        if (typeof this.webContents === 'object') {
            this.webContents.send(this.channel, info);
        }

        callback();
    }
}

export default IpcTransport;
